var map = {
	"./loader-1.webp": 851,
	"./loader-2.webp": 130,
	"./loader-3.webp": 2893,
	"./loader-4.webp": 1820,
	"./loader-5.webp": 8911,
	"./loader-6.webp": 6462,
	"./loader-7.webp": 6185,
	"./loader-8.webp": 8632,
	"./loader-9.webp": 1451,
	"./loader-91.webp": 8674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5483;